import React, { useState } from 'react';
import ActivityLoader from '../../Common/ActivityLoader';
import BsModal from '../../Common/BsModal';
import { useTheme } from '../../../DataStore/ThemeContext';
import Notification from '../../Common/Notification';
import { usePermission } from '../../../DataStore/PermissionContext';
import ajaxUser from '../../../util/remote/ajaxUser';

const AlertRevokePermission = () => {

    const [loading, setLoading] = useState(false);
    const {setNotify} = useTheme();

    const { accessRevoke, setAccessRevoke } = usePermission();

    const handleClose = () => setAccessRevoke({ show: false, accessIds: null });


   if (!accessRevoke.accessIds) return null;
  
   

    const confirm = async()=>{
        setLoading(true);
        const server_response = await ajaxUser.revokeMultiPermissions({access_ids: accessRevoke.accessIds});
        setLoading(false);
        if(server_response.status === "OK"){
            accessRevoke.callback();
            setNotify(<Notification type='success' message={server_response.message}/>)
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>)

        }
        handleClose();
    }

    return (
        <BsModal
            show={accessRevoke.show}
            onClose={handleClose}
            title="Revoke Role Permissions"
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && <>
                    <button className="btn btn-modern-secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-modern-danger" onClick={confirm}>
                        Revoke Permissions
                    </button>
                    </>}
                </>
            }
        >


            {accessRevoke.accessIds && <div className="text-center py-4">
                <div className="delete-icon-wrapper">
                        <i className="fa-regular fa-circle-question"></i>
                    </div>
                 <h5 className="delete-title">Please confirm that you want to revoke the selected role permissions.</h5>

                <div className="delete-note-box">
                    <p className="mb-0">
                        <strong>Note:</strong> All users with this role will lose the permissions associated with it.
                    </p>
                </div>
           
            </div>}
          

        </BsModal>
    );
};

export default AlertRevokePermission;
